/**@file: 路由文件 */
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const _import_ = file => () => import('../views/' + file + '.vue');
const routes = [{
		path: '/',
		name: 'Home',
		component: _import_('Home'),
		redirect: '/index/homePage',

		children: [{
			path: '/index/homePage',
			name: 'homePage',
			meta: {
				title: '招标公告--甘肃锦世化工招投标采购平台'
			},
			component: _import_('Index/homePage'),
		}
		,{
			path: '/index/gongshi',
			name: 'gongshi',
			meta: {
				title: '中标公示--甘肃锦世化工招投标采购平台'
			},
			component: _import_('Index/gongshi'),
		}
		,{
			path: '/index/detail',
			name: 'detail',
			meta: {
				title: '招标详情--甘肃锦世化工招投标采购平台'
			},
			component: _import_('Index/detail'),
		}
		,{
			path: '/index/login',
			name: 'login',
			meta: {
				title: '会员登录--甘肃锦世化工招投标采购平台'
			},
			component: _import_('Index/login'),
		}
		,{
			path: '/index/mybaojia',
			name: 'mybaojia',
			meta: {
				title: '我的报价列表--甘肃锦世化工招投标采购平台',
				auth: true,
			},
			component: _import_('Index/mybaojia'),
		}
		,{
			path: '/index/mydetail',
			name: 'mydetail',
			meta: {
				title: '我的报价详情--甘肃锦世化工招投标采购平台',
				auth: true,
			},
			component: _import_('Index/mydetail'),
		}
		,{
			path: '/index/register',
			name: 'register',
			meta: {
				title: '会员注册--甘肃锦世化工招投标采购平台'
			},
			component: _import_('Index/register'),
		}
		]
	},
	// {
	// 	path: '/login',
	// 	name: 'Login',
	// 	component: _import_('Login'),
	// }
];

const router = new VueRouter({
	mode: 'hash',//history
	base: process.env.BASE_URL,
	routes
});

export default router;
